import { apiService } from "@/common/api.service.js";

export default {
//
// ALARMS
//

  getSearchAlarms() {
    let endpoint = `/api/alarms-search/`;
    return apiService(endpoint);
  },
  getAllAlarms() {
    let endpoint = `/api/alarms-all/`;
    return apiService(endpoint);
  },

  searchAlarmQuery(searchQuery) {
    let endpoint = `/api/alarms/?search=${searchQuery}`;
    return apiService(endpoint);
  },

  alarmCreate(payload) {
    let endpoint = `/api/alarm-create/`;
    return apiService(endpoint, "POST", payload)
  },

  alarmData(alarmId) {
    let endpoint = `/api/alarms/${alarmId}/`;
    return apiService(endpoint);
  },

  alarmUpdate(payload) {
    let endpoint = `/api/alarm-update/${payload.id}/`;
    return apiService(endpoint, "PATCH", payload);
  },

  nestedSitesAndAlarms() {
    let endpoint = `/api/nested-site-alarms/`;
    return apiService(endpoint);
  },

}